import { render, staticRenderFns } from "./Listposition.vue?vue&type=template&id=003590be&"
import script from "./Listposition.vue?vue&type=script&lang=js&"
export * from "./Listposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports